import TableFilter from '../plugins/tableFilterPlugin';
import aosInit from './aosInit';

export default function initTableFilter() {
  document.querySelectorAll('.offers-section').forEach((holder) => {
    new TableFilter(holder, {
      table: '.main-table > .container > .offers-table',
      filtersWrap: '.filter-holder',
      roomsFilter: '[data-filter="rooms"]',
      typesFilter: '[data-filter="type"]',
      disabledFilter: '[data-filter="available"]',
      priceMinFilter: '#min-price',
      priceMaxFilter: '#max-price',
      filtered() {
        const sectionTop = document.querySelector('.offers-section .sticky-wrap-section-top');
        if (sectionTop && sectionTop.classList.contains('fixed-position')) {
          jQuery('html, body').stop().animate({scrollTop: jQuery(holder).offset().top - jQuery('#header').outerHeight()}, 500);
        }
        jQuery('.filter-open-close').openClose('hideSlide');
        function reInit() {
          const stickyInst = jQuery(holder).find('.section-top').data('StickyScrollBlock');
          stickyInst.resetState();
          stickyInst.recalculateOffsets();
          stickyInst.checkStickyPermission();
          stickyInst.scrollHandler();
          aosInit();
        }
        setTimeout(reInit, 500);
      }
    });
  });
}